import { Vertical } from '@weave/schema-gen-ts/dist/shared/vertical/vertical.pb';
import { useLastUsedVerticalShallowStore } from '@frontend/location-helpers';
import { useAppScopeStore } from '@frontend/scope';

export const useGetIsValidInsuranceVertical = (locationId: string) => {
  const { lastUsedVertical } = useLastUsedVerticalShallowStore('lastUsedVertical');
  const { accessibleLocationData } = useAppScopeStore();
  const locationVertical = accessibleLocationData?.[locationId]?.vertical || '';
  const isDental = locationVertical === Vertical.DENTAL || lastUsedVertical === 'DENTAL';
  const isWellness = locationVertical === Vertical.WELLNESS || lastUsedVertical === 'WELLNESS';
  const isOtherVertical = locationVertical === Vertical.OTHER || lastUsedVertical === 'OTHER';
  // Insurance verification is only available for Dental, Wellness and others (Wellness and others is the medical vertical for insurance verification which is mapped by Salesforce team in WAM)
  return isDental || isWellness || isOtherVertical;
};
